import React, {useEffect} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import PayslipSampleGenerator from '../common/PayslipSampleGenerator'


// import mcDonaldsLogo from '../assets/images/mc-donalds.png';
// import myokaLogo from '../assets/images/myoka.png';
// import skySpiritLogo from '../assets/images/sky-spirit.png';


function EasyToFollowPricing({

}) {


  return (

    <div id='features' className="py-16 bg-gray-50 overflow-hidden lg:py-24">
      <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-screen-xl">

        <svg className="hidden lg:block absolute right-full transform translate-x-1/2 translate-y-12" width="404" height="784" fill="none" viewBox="0 0 404 784">
          <defs>
            <pattern id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="404" height="784" fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
        </svg>

        <div className="relative">
          <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
            <div className="lg:col-start-2">
              <h4 className="text-2xl leading-8 font-extrabold text-gray-900 tracking-tight sm:text-3xl sm:leading-9">
                Fair Pricing Policy
              </h4>
              <p className="mt-3 text-lg leading-7 text-gray-500">
                Buddy's credit-based pricing allows you to only pay for what you consume.
              </p>

              <ul className="mt-10">
                <li>
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                        {/* Heroicon name: annotation */}
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Detailed Credit History</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Our Detailed credit history allows you to view how many credits you have at any point.
                        Including when and why they were consumed.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                        {/* Heroicon name: mail */}
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">No Expiry</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Buddy's Credits do not come with an expiry date.
                        Hence you can choose how much to purchase, go for big savings or smaller purchases for improved cashflow. 
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                        {/* Heroicon name: mail */}
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Pay only for what you need</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Payroll has never been so cost-effective.
                        With ever-changing life and business scenarios it is close to impossible to buy the right amount of 'licenses'.
                        Buddy takes away the guess work, and you're guaranteed to never overpay for your payroll needs.
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="mt-10 -mx-4 relative lg:mt-0 lg:col-start-1">
              <svg className="fixed left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden" width="784" height="404" fill="none" viewBox="0 0 784 404">
                <defs>
                  <pattern id="e80155a9-dfde-425a-b5ea-1f6fadd20131" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                  </pattern>
                </defs>
                <rect width="784" height="404" fill="url(#e80155a9-dfde-425a-b5ea-1f6fadd20131)" />
              </svg>
              <div>
                <div className="flex flex-col" style={{maxWidth: 500}}>
                  <div className="-my-2 overflow-x-auto">
                    <div className="py-2 align-middle inline-block min-w-full">
                      <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead>
                            <tr>
                              <th className="px-4 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                Date
                              </th>
                              <th className="px-4 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                Credits
                              </th>
                              <th className="px-4 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                Balance
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            <tr>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <div className="text-sm leading-5 text-gray-500">
                                  15 Jan 2020
                                </div>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <span className="text-sm leading-5 text-green-800">+1000</span>
                                <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                  INV-0001
                                </span>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap text-sm">
                                1000
                              </td>
                            </tr>
                            <tr>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <div className="text-sm leading-5 text-gray-500">
                                  15 Jan 2020
                                </div>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <span className="text-sm leading-5 text-green-800">+200</span>
                                <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                  Bonus Credits
                                </span>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap text-sm">
                                1200
                              </td>
                            </tr>

                            <tr>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <div className="text-sm leading-5 text-gray-500">
                                  28 Jan 2020
                                </div>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <span className="text-sm leading-5 text-red-800">-60</span>
                                <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                                  January Payroll
                                </span>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap text-sm">
                                1140
                              </td>
                            </tr>

                            <tr>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <div className="text-sm leading-5 text-gray-500">
                                  26 Feb 2020
                                </div>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <span className="text-sm leading-5 text-red-800">-62</span>
                                <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                                  February Payroll
                                </span>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap text-sm">
                                1078
                              </td>
                            </tr>

                            <tr>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <div className="text-sm leading-5 text-gray-500">
                                  27 Mar 2020
                                </div>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <span className="text-sm leading-5 text-red-800">-61</span>
                                <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                                  March Payroll
                                </span>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap text-sm">
                                1017
                              </td>
                            </tr>

                            <tr>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <div className="text-sm leading-5 text-gray-500">
                                  26 April 2020
                                </div>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <span className="text-sm leading-5 text-red-800">-55</span>
                                <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                                  April Payroll
                                </span>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap text-sm">
                                962
                              </td>
                            </tr>

                            <tr>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <div className="text-sm leading-5 text-gray-500">
                                  29 May 2020
                                </div>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <span className="text-sm leading-5 text-red-800">-60</span>
                                <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                                  May Payroll
                                </span>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap text-sm">
                                902
                              </td>
                            </tr>

                            <tr>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <div className="text-sm leading-5 text-gray-500">
                                  28 June 2020
                                </div>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap">
                                <span className="text-sm leading-5 text-red-800">-72</span>
                                <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                                  June Payroll
                                </span>
                              </td>
                              <td className="px-4 py-4 whitespace-no-wrap text-sm">
                                830
                              </td>
                            </tr>


                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EasyToFollowPricing) 
